export const isMobile = (device) => device === 'mobile';
export const isTablet = (device) => device === 'tablet';
export const isDesktop = (device) => device === undefined;
export const isMacOS = (os) => os?.startsWith('mac');
